import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import {
  buildJobApplicationCounts,
  type JobApplicationCountRow,
} from '@/lib/forkhire/workflow/jobCardApplicationCounts';

interface JobAppCounts {
  [jobId: string]: number;
}

export function useJobApplicationCountsBulk(jobIds: string[]) {
  const jobKey = [...jobIds].sort().join(',');

  return useQuery({
    queryKey: ['job-app-counts-bulk', jobKey],
    queryFn: async () => {
      if (!jobIds.length) return {} as JobAppCounts;

      const { data, error } = await supabase
        .from('applications')
        .select('job_id, stage, status, source, cv_scores(total_score)')
        .in('job_id', jobIds);

      if (error) throw error;

      return buildJobApplicationCounts(jobIds, (data || []) as JobApplicationCountRow[]);
    },
    enabled: jobIds.length > 0,
    staleTime: 30_000,
  });
}
